import { Helmet } from "react-helmet-async";

/**
 * Tiny per-route SEO helmet.
 * - Sets <title>, meta description, canonical, OpenGraph + Twitter
 * - Optional `jsonLd` for page-specific structured data
 */
export function Seo({
  title,
  description,
  path = "/",
  image,
  noindex = false,
  jsonLd = null,
}) {
  const base = "https://sabzy.in";
  const url = `${base}${path}`;
  const fullTitle = title?.includes("Sabzy") ? title : `${title} | Sabzy AI`;
  const ogImage = image || `${base}/og-image.png`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large"} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
